/**
 * Application Entry Point
 * MJJ 交易工具 - VPS/域名交易卡片生成器
 * Requirements: 技術架構 - 純前端應用
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import './index.css'
import { router } from './router'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
